import { Info, Scale } from "lucide-react";
interface NutritionalInfoProps {
  calories: number;
  carbs: number;
  protein: number;
  fat: number;
  portionSizeValue?: number;
  portionSizeUnit?: string;
}
export const NutritionalInfo = ({
  calories,
  carbs,
  protein,
  fat,
  portionSizeValue,
  portionSizeUnit
}: NutritionalInfoProps) => {
  return <div className="space-y-3">
      <h3 className="font-semibold flex items-center text-black">
        <Info className="w-4 h-4 mr-2" />
        Nutritional Information
      </h3>
      
      {portionSizeValue && portionSizeUnit && <div className="flex items-center text-sm text-muted-foreground mb-2">
          
          <span>Per portion: {portionSizeValue} {portionSizeUnit}</span>
        </div>}
      
      <div className="grid grid-cols-4 gap-4">
        <div className="text-center">
          <p className="font-medium text-sm">{calories}</p>
          <p className="text-xs text-muted-foreground">Calories</p>
        </div>
        <div className="text-center">
          <p className="font-medium text-sm">{carbs}g</p>
          <p className="text-xs text-muted-foreground">Carbs</p>
        </div>
        <div className="text-center">
          <p className="font-medium text-sm">{protein}g</p>
          <p className="text-xs text-muted-foreground">Protein</p>
        </div>
        <div className="text-center">
          <p className="font-medium text-sm">{fat}g</p>
          <p className="text-xs text-muted-foreground">Fat</p>
        </div>
      </div>
    </div>;
};